"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BASE_URL: 'https://app.drift.com',
  BASE_DOMAIN: 'app.drift.com',
  CLIENT_ID: '1UDhLV0zBBVZo3',
  PUSH_WS: 'push.api.drift.com',
  RELEASE_URL: 'https://api.drift.com/releases',
  SENTRY_DSN: 'https://7325d27a5c424d9bacd9d2f0c8c6f016@sentry.io/1784185',
  IFRAMELY_API_KEY: '<IFRAMELY_API_KEY>',
  REDUX_STORE_PREFIX: 'convo'
};